import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import {
  FeatureNames,
  ActivateDeactivateCommands,
  SetNumberValueCommands,
  FeatureCommands,
  Feature,
  IsActiveProperty,
  IsNumberValueProperty,
  FeaturePropertyKey,
  TariffBasedFinancialOptimizationStateProperty,
  TariffBasedFinancialOptimizationStateCommands,
} from '@vi-iot/client';

import { DevicesStore, HemsStore, InstallationFeaturesStore } from '@store';
import { UIService } from '@services';
import { FeaturesDetailsOverlayTypeEnum } from '../../installation-overlay.model';

@Component({
  selector: 'app-hems-settings',
  templateUrl: './hems-settings.component.html',
  styleUrls: ['./hems-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HemsSettingsComponent implements OnInit {
  photovoltaicExcess$: Observable<Feature<IsActiveProperty, ActivateDeactivateCommands>>;
  photovoltaicPvExcess$: Observable<Feature<IsActiveProperty, ActivateDeactivateCommands>>;
  solarIrradiance$: Observable<Feature<IsActiveProperty, ActivateDeactivateCommands>>;
  forecastBased$: Observable<Feature<IsActiveProperty, ActivateDeactivateCommands>>;
  overloadProtection$: Observable<Feature<IsActiveProperty, ActivateDeactivateCommands>>;
  gridCurrentLimit$: Observable<Feature<IsNumberValueProperty, SetNumberValueCommands>>;
  featureTariffBasedFinancialOptimizationState$: Observable<
    Feature<
      TariffBasedFinancialOptimizationStateProperty,
      TariffBasedFinancialOptimizationStateCommands
    >
  >;
  featureAllowBatteryChargingFromTheGrid$: Observable<
    Feature<IsActiveProperty, ActivateDeactivateCommands>
  >;

  featureHeatpump$: Observable<Feature<IsActiveProperty, ActivateDeactivateCommands>>;
  readonly featureCommands = FeatureCommands;
  readonly featurePropertyKey = FeaturePropertyKey;

  constructor(
    public devicesStore: DevicesStore,
    public hemsStore: HemsStore,
    private installationFeaturesStore: InstallationFeaturesStore,
    private uiService: UIService
  ) {}

  ngOnInit(): void {
    this.photovoltaicExcess$ = this.installationFeaturesStore.selectInstallationHemsFeature(
      FeatureNames.photovoltaicExcessHeatpumpHandling
    );
    this.photovoltaicPvExcess$ = this.installationFeaturesStore.selectInstallationHemsFeature(
      FeatureNames.photovoltaicExcessPvHandling
    );
    this.solarIrradiance$ = this.installationFeaturesStore.selectInstallationHemsFeature(
      FeatureNames.onlineSolarIrradianceForecast
    );
    this.forecastBased$ = this.installationFeaturesStore.selectInstallationHemsFeature(
      FeatureNames.forecastBasedBatteryOperation
    );
    this.overloadProtection$ = this.installationFeaturesStore.selectInstallationHemsFeature(
      FeatureNames.overloadProtection
    );
    this.gridCurrentLimit$ = this.installationFeaturesStore.selectInstallationHemsFeature(
      FeatureNames.gridCurrentLimit
    );
    this.featureTariffBasedFinancialOptimizationState$ = this.installationFeaturesStore.selectInstallationHemsFeature(
      FeatureNames.emsHocaFeaturesTriffBasedFinancialOptimizationState
    );
    this.featureAllowBatteryChargingFromTheGrid$ = this.installationFeaturesStore.selectInstallationHemsFeature(
      FeatureNames.emsHocaFeaturesAllowBatteryChargingFromTheGrid
    );
    this.featureHeatpump$ = this.installationFeaturesStore.selectInstallationHemsFeature(
      FeatureNames.emsHocaFeaturesHeatpumpOnly
    );
  }

  onOpenChargingMode(wallBoxDeviceSelectId): void {
    this.devicesStore.setSelectedDevice(wallBoxDeviceSelectId);
    this.uiService.openActiveOverlay(FeaturesDetailsOverlayTypeEnum.WallboxChargingSettings);
  }
}
